import {
	FaReact,
	FaNodeJs,
	FaAws,
	FaGoogle,
} from "react-icons/fa";
import { GrGraphQl } from "react-icons/gr";

export const timelineObjects = [
	{
		position: "Machine Learning Software Engineer",
		company: "Loblaw Digital",
		fields: ["GenerativeAI", "Digital Logistics", "Cloud Infrastructure"],
		start: "Jan 2026",
		conclusion: "Present",
		stack: [
			{
				label: "GCP",
				icon: <FaGoogle className='timelineicon gcp'/>
			},
			{
				label: "Python",
				icon: (
					<img
						src={require("../../images/python.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
			{
				label: "LangChain",
				icon: (
					<img
						src={require("../../images/langchain.png")}
						alt=""
						className="timeline timelineicon-lg"
					/>
				),
			},
			{
				label: "LangFuse",
				icon: (
					<img
						src={require("../../images/langfuse.png")}
						alt=""
						className="timeline timelineicon-lg"
					/>
				),
			},
			{
				label: "BigQuery",
				icon: (
					<img
						src={require("../../images/bigquery.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
		],
	},
	{
		position: "Software Engineer",
		company: "Johnson Controls",
		fields: ["Security", "Industrial", "Cloud Infrastructure"],
		start: "May 2024",
		conclusion: "April 2025",
		stack: [
			{
				label: "Node",
				icon: <FaNodeJs className="n timelineicon" />,
			},
			{
				label: "AWS",
				icon: <FaAws className="j timelineicon" />,
			},
		],
	},
	{
		position: "Founding Software Engineer",
		company: "Project: Human City",
		fields: ["Startup", "Public", "Software Development"],
		start: "April 2023",
		conclusion: "March 2024",
		stack: [
			{
				label: "React.js",
				icon: <FaReact className="timelineicon r" />,
			},
			{
				label: "TypeScript",
				icon: (
					<img
						src={require("../../images/ts.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
			{
				label: "Python",
				icon: (
					<img
						src={require("../../images/python.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
			{
				label: "GraphQL",
				icon: <GrGraphQl className="timelineicon text-blue" />,
			},
		],
	},
	{
		position: "Software Engineer Intern",
		company: "Project: Human City",
		fields: ["Startup", "Public", "Software Development"],
		start: "January 2023",
		conclusion: "April 2023",
		stack: [
			{
				label: "React.js",
				icon: <FaReact className="timelineicon r" />,
			},
			{
				label: "TypeScript",
				icon: (
					<img
						src={require("../../images/ts.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
			{
				label: "Material UI",
				icon: (
					<img
						src={require("../../images/mui.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
		],
	},
	{
		position: "Web Developer (Operations)",
		company: "Google Developer Student Club",
		fields: ["Student Org", "Public", "Club Operations"],
		start: "September 2023",
		conclusion: "Present",
		stack: [
			{
				label: "Next.js",
				icon: (
					<img
						src={require("../../images/nextjs.png")}
						alt=""
						className="timelineicon-n"
					/>
				),
			},
			{
				label: "Trello",
				icon: (
					<img
						src={require("../../images/trello.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
			{
				label: "TailwindCSS",
				icon: (
					<img
						src={require("../../images/tailwind.png")}
						alt=""
						className="timelineicon"
					/>
				),
			},
		],
	},
];
